<template>
    <el-form v-if="model" ref="form" :model="model" :rules="rules" label-width="180px">
        <el-form-item label="姓名" prop="name">
            <el-input v-model="model.name"></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
            <el-input v-model="model.nickname"></el-input>
        </el-form-item>
        <el-form-item label="所属部门" prop="branch_id">
            <el-cascader
                    :options="branchesTree"
                    v-model="checkedBranch"
                    :props="branchesProps"
                    change-on-select
                    placeholder="请选择所属部门"
                    style="width:100%"
            >
            </el-cascader>
        </el-form-item>
        <el-form-item label="职位" prop="role_id">
            <el-select v-model="model.role_id" style="width:100%" placeholder="请选择职位" @change="handleRoleChange">
                <el-option
                        v-for="item in roles"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                >
                </el-option>
            </el-select>
            <div v-if="getRoleCapacityConflictMessage()" class="role-capacity-warning">{{getRoleCapacityConflictMessage()}}</div>
        </el-form-item>
        <el-form-item label="密码" prop="password_hash">
            <el-input v-model="model.password_hash"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
            <el-input v-model="model.mobile"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
            <el-input v-model="model.email"></el-input>
        </el-form-item>
        <el-form-item label="钉钉uid" prop="dingding_user_id">
            <el-input v-model="model.dingding_user_id"></el-input>
        </el-form-item>
        <el-form-item label="入职时间" prop="entry_at">
            <el-date-picker
            v-model="model.entry_at"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择入职时间"
            >
            </el-date-picker>
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
            <el-switch active-color="#13ce66" active-value="1" inactive-value="0" v-model="model.status">
            </el-switch>
        </el-form-item>
        <el-form-item label="设为公用" prop="is_common">
            <el-switch active-color="#13ce66" active-value="1" inactive-value="0" v-model="model.is_common">
            </el-switch>
        </el-form-item>
        <el-form-item label="QQ" prop="qq">
            <el-input v-model="model.qq"></el-input>
        </el-form-item>
        <el-form-item label="微信二维码" prop="qr_code">
            <el-upload
                    name="qr_code"
                    class="avatar-uploader"
                    action="/api/users/upload-qr"
                    :show-file-list="false"
                    :http-request="uploadQrRequest"
                    :on-success="uploadQrCallback"
                    :before-upload="beforeUploadQr">
                <img v-if="model.qr_code" :src="model.qr_code" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </el-form-item>

        <el-form-item v-if="isBusiness" label="最大绑定客户上限" prop="max_customer_limit">
            <el-input-number
                    v-model="model.max_customer_limit"
                    :min="0"
                    :precision="0"
                    :controls="false">
            </el-input-number>
            <span class="capacity-tip">职位最高可设置 {{getRoleCapacity('max_customer_limit')}}</span>
        </el-form-item>

        <el-form-item v-if="isBusiness" label="最大绑定A类客户上限" prop="max_vip_limit">
            <el-input-number
                    v-model="model.max_vip_limit"
                    :min="0"
                    :precision="0"
                    :controls="false">
            </el-input-number>
            <span class="capacity-tip">职位最高可设置 {{getRoleCapacity('max_vip_limit')}}</span>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="submitForm()">立即保存</el-button>
            <el-button v-if="scenario == 'create'" @click="resetForm()">重置</el-button>
        </el-form-item>
    </el-form>
</template>

<style>
    .role-capacity-warning {
        margin-top: 8px;
        color: #F56C6C;
        line-height: 20px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .capacity-tip {
        margin-left: 10px;
        color: #909399;
    }

    .el-input-number {
        width: 220px;
    }
</style>

<script>
    import CommonService from "~/services/common";
    import {BranchService} from "~/services/Branch";
    import UserService from "~/services/user";

    export default {
        name: "subForm",
        data() {
            return {
                // 是否是业务员
                isBusiness: false,
                branchesTree: [],
                branchesProps: {
                    value: 'id',
                    label: 'name',
                    children: 'childs'
                },
                checkedBranch: [],
                roles: [],
                rules: {
                    name: [
                        {
                            required: true,
                            message: "请输入用户姓名",
                            trigger: "blur"
                        },
                    ],
                    nickname: [
                        {max: 120, message: "昵称长度太长", trigger: "blur"}
                    ],
                    branch_id: [
                        {
                            required: true,
                            message: "请正确选择所属部门",
                            trigger: "blur"
                        }
                    ],
                    role_id: [
                        {
                            required: true,
                            message: "请选择职位",
                            trigger: "blur"
                        }
                    ],
                    entry_at: [
                        {
                            required: true,
                            message: "请选择入职时间",
                            trigger: "blur"
                        }
                    ],
                    password_hash: [
                        {
                            required: true,
                            message: "密码不允许为空",
                            trigger: "blur"
                        },
                        {
                            min: 6,
                            max: 12,
                            message: "密码长度最小6位最大不超过12位"
                        }
                    ],
                    mobile: [
                        {
                            required: true,
                            message: "请输入手机号",
                            trigger: "blur"
                        },
                        {
                            min: 11,
                            max: 11,
                            message: "请正确输入11位手机号",
                            trigger: "blur"
                        }
                        //{ pattern: "/^1[3578]\d{9}$/", message: "手机号格式错误"}
                    ],
                    email: [
                        {
                            required: true,
                            message: "请输入正确的邮箱",
                            type: "email",
                            trigger: "blur"
                        },
                        {max: 120, message: "邮箱长度太长", trigger: "blur"}
                    ],
                    dingding_user_id: [
                        {
                            required: true,
                            message: "请输入钉钉uid",
                            trigger: "blur"
                        },
                    ],
                    status: [{required: true, message: "状态不允许为空"}]
                }
            };
        },
        props: {
            model: {
                type: Object,
                required: true
            },
            scenario: {
                type: String,
                required: true
            }
        },
        created() {

            if (this.branchesTree.length <= 0) {
                this.getBranchTreeStructure();
            }

            if (this.roles.length <= 0) {
                this.getRoles();
            }

            if (this.scenario == "update") {
                // 编辑时密码可以为空
                this.rules.password_hash.splice(0, 1);
            }
            // 编辑状态下使用服务端返回的部门完整路径填充部门联动组件
            if (this.model.id > 0 && this.model.branch_full_path) {
                this.checkedBranch = this.model.branch_full_path;
            }
            console.log('进入：', this.model);
        },
        watch: {
            checkedBranch: function (value, original) {
                if (value.length > 0) {
                    // 取得最后一级部门作为所属部门
                    this.model.branch_id = value[value.length - 1];
                    this.getBranchInfo(this.model.branch_id);
                } else {
                    this.model.branch_id = "";
                }
            }
        },
        methods: {

            /**
             * 得到部门树状结构数据
             */
            getBranchTreeStructure() {
                CommonService.getAllBranches().then(res => {
                    if (res.code == 0 && res.data) {
                        let branches = res.data;
                        delete branches[0];
                        this.branchesTree = res.data;
                    }
                });
            },

            /**
             * 得到角色下拉选项
             */
            getRoles() {
                CommonService.getAllRoles().then(res => {
                    if (res && res.code == 0) {
                        this.roles = res.data.map(role => {
                            role.max_customer_limit = parseInt(role.max_customer_limit) || 0;
                            role.max_vip_limit = parseInt(role.max_vip_limit) || 0;
                            return role;
                        });
                        this.applyRoleCapacity();
                    }
                }).catch(err => {
                    console.error(err);
                })
            },

            //提交表单
            submitForm() {
                var from_data = this.model;
                if (!this.validateRoleCapacity()) {
                    return false;
                }
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.$emit("submit", from_data);
                    } else {
                        return false;
                    }
                });
            },

            // 重置表单
            handleRoleChange() {
            },

            getSelectedRole() {
                return this.roles.find(role => parseInt(role.id) === parseInt(this.model.role_id));
            },

            getRoleCapacity(field) {
                let role = this.getSelectedRole();
                if (!role) {
                    return 0;
                }
                return parseInt(role[field]) || 0;
            },

            getRoleCapacityConflictMessage() {
                if (!this.isBusiness || !this.model.role_id || this.roles.length <= 0) {
                    return "";
                }

                let messages = [];
                let customerLimit = this.getRoleCapacity("max_customer_limit");
                let userCustomerLimit = parseInt(this.model.max_customer_limit) || 0;
                if (customerLimit > 0 && userCustomerLimit > customerLimit) {
                    messages.push("个人客户上限(" + userCustomerLimit + ")大于职位客户上限(" + customerLimit + ")");
                }

                let vipLimit = this.getRoleCapacity("max_vip_limit");
                let userVipLimit = parseInt(this.model.max_vip_limit) || 0;
                if (vipLimit > 0 && userVipLimit > vipLimit) {
                    messages.push("个人A类客户上限(" + userVipLimit + ")大于职位A类客户上限(" + vipLimit + ")");
                }

                return messages.length > 0 ? "个人库容上限已超过职位库容上限，请先进行调整：" + messages.join("；") : "";
            },

            applyRoleCapacity() {
                if (!this.isBusiness || this.scenario !== "create" || this.roles.length <= 0 || !this.model.role_id) {
                    return;
                }

                let customerLimit = this.getRoleCapacity("max_customer_limit");
                if (customerLimit > 0 && (parseInt(this.model.max_customer_limit) || 0) <= 0) {
                    this.model.max_customer_limit = customerLimit;
                }

                let vipLimit = this.getRoleCapacity("max_vip_limit");
                if (vipLimit > 0 && (parseInt(this.model.max_vip_limit) || 0) <= 0) {
                    this.model.max_vip_limit = vipLimit;
                }
            },

            validateRoleCapacity() {
                if (this.getRoleCapacityConflictMessage()) {
                    this.$message.error("个人库容上限已超过职位库容上限，请先进行调整");
                    return false;
                }

                if (!this.isBusiness) {
                    return true;
                }

                let customerLimit = this.getRoleCapacity('max_customer_limit');
                let userCustomerLimit = parseInt(this.model.max_customer_limit) || 0;
                if (customerLimit > 0 && (userCustomerLimit <= 0 || userCustomerLimit > customerLimit)) {
                    this.$message.error('个人客户上限不能超过职位客户上限(' + customerLimit + ')');
                    return false;
                }

                let vipLimit = this.getRoleCapacity('max_vip_limit');
                let userVipLimit = parseInt(this.model.max_vip_limit) || 0;
                if (vipLimit > 0 && (userVipLimit <= 0 || userVipLimit > vipLimit)) {
                    this.$message.error('个人A类客户上限不能超过职位A类客户上限(' + vipLimit + ')');
                    return false;
                }

                return true;
            },

            resetForm() {
                this.$refs["form"].resetFields();
            },

            /**
             * 上传二维码之前触发的回调
             * @param file
             * @returns {boolean}
             */
            beforeUploadQr(file) {
                let allowMimeTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
                if (allowMimeTypes.indexOf(file.type) < 0) {
                    this.$message.error("只支持上传文件格式 jpeg|jpg|png|gif");
                    return false;
                }

                const isLt2M = file.size / 1024 < 800;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 800 KB !');
                    return false;
                }

                return true;
            },

            uploadQrCallback(res, file) {
                this.qr_code = URL.createObjectURL(file.raw);
            },

            /**
             * 处理上传二维码请求
             * @param param
             */
            uploadQrRequest(param) {
                UserService.uploadQRCode(param.file).then(res => {
                    if (res && res.code == 0) {
                        this.model.qr_code = res.data.qr_code;
                    }
                }).catch(err => {
                    console.error(err);
                })
            },

            getBranchInfo(branchId) {
                BranchService.getBranchInfo(branchId).then(res => {
                    if (res.code == 0) {
                        let branch = res.data;
                        this.isBusiness = branch.is_business;
                        this.applyRoleCapacity();
                    }
                })
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/user/form.vue